// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__sfcYT","errorLogs":"styles_errorLogs__2gtgH"};